namespace RioERP.Masters {
    export interface WhatsAppTemplatesForm {
        TemplateName: Serenity.StringEditor;
        Wid: Serenity.IntegerEditor;
        Variable: Serenity.LookupEditor;
        Status: Serenity.EnumEditor;
        LanguageCode: Serenity.StringEditor;
        MessagingProduct: Serenity.StringEditor;
        Type: Serenity.EnumEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class WhatsAppTemplatesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.WhatsAppTemplates';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhatsAppTemplatesForm.init)  {
                WhatsAppTemplatesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(WhatsAppTemplatesForm, [
                    'TemplateName', w0,
                    'Wid', w1,
                    'Variable', w2,
                    'Status', w3,
                    'LanguageCode', w0,
                    'MessagingProduct', w0,
                    'Type', w3,
                    'IsActive', w4
                ]);
            }
        }
    }
}
